@file:OptIn(ExperimentalSerializationApi::class)
@file:Suppress("unused")

package org.ssoft.common.server.portal

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.LocalTime
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.Serializable
import kotlinx.serialization.protobuf.ProtoNumber

object PortalIO {

    interface EntryFilter {
        var id: Long
        var name: String

        val idHex
            get() = id.toString()
                .dropLast(3)
                .toLongOrNull()
                ?.toString(16)
                ?.uppercase()
                ?: id.toString()
    }

    interface ImplServer {
        var imageLogoHorizontal: Long
        var imageLogoSquare: Long

        companion object {
            const val DEFAULT_IMAGE_HORIZONTAL = -29L
            const val DEFAULT_IMAGE_SQUARE = -30L
            const val DEFAULT_IMAGE_ICO = -28L
        }
    }

    @Serializable
    data class ListingDomain(
        @ProtoNumber(1)
        var items: MutableList<Item> = mutableListOf()
    ) {
        @Serializable
        data class Item(
            @ProtoNumber(1)
            override var id: Long,
            @ProtoNumber(2)
            override var name: String,
            @ProtoNumber(3)
            var title: String = "ScreenSoft",
            @ProtoNumber(4)
            var ico: Long = ImplServer.DEFAULT_IMAGE_ICO,
            @ProtoNumber(5)
            var urls: Urls = Urls(),
        ) : EntryFilter

        @Serializable
        data class Urls(
            @ProtoNumber(1)
            var home: String = "screensoft.org",
            @ProtoNumber(2)
            var control: String = "my.screensoft.org",
            @ProtoNumber(3)
            var game: String = "game.screensoft.org",
        )
    }
}